"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NuiAppSecLogCategory = exports.AppSecLogger = void 0;
var _os = _interopRequireDefault(require("os"));
var _config = _interopRequireDefault(require("../config"));
var _logProvider = require("../logProvider");
var _transform = require("../logger/transform");
var _NuiLogValidator = require("../NuiLogValidator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable camelcase */
var EventType = Object.freeze({
  authzFailed: 'authz_failed',
  authzSuccessful: 'authz_successful',
  authnFailed: 'authn_failed',
  authnSuccessful: 'authn_successful',
  configCreated: 'config_created',
  configUpdated: 'config_updated',
  configRemoved: 'config_removed',
  validationFailure: 'validation_failure',
  notFound: 'not_found',
  userCreated: 'user_created',
  userDeactivated: 'user_deactivated',
  userReactivated: 'user_reactivated',
  userPermissionsChanged: 'user_permissions_changed',
  userAuthChanged: 'user_auth_changed',
  keyChanged: 'key_changed',
  keyLoaded: 'key_loaded',
  cardDataAccess: 'card_data_access',
  appsecLogAccess: 'appsec_log_access',
  appsecLogStarted: 'appsec_log_started',
  appsecLogStopped: 'appsec_log_stopped',
  appsecLogPaused: 'appsec_log_paused',
  userLogin: 'user_login',
  userLogout: 'user_logout',
  startup: 'startup',
  shutdown: 'shutdown',
  deployment: 'deployment',
  // should be handled by RPL
  externalExecution: 'external_execution',
  protectionSystemDeactivated: 'protection_system_deactivated',
  protectionSystemActivated: 'protection_system_activated',
  fileAccessR: 'file_access_r',
  fileAccessW: 'file_access_w',
  serverSocketOpened: 'server_socket_opened',
  dataImport: 'data_import',
  dataExport: 'data_export',
  fileUpload: 'file_upload'
});
// export with matching name to the TS declaration
var NuiAppSecLogCategory = exports.NuiAppSecLogCategory = EventType;
var AppSecLogger = exports.AppSecLogger = /*#__PURE__*/function () {
  /**
   * Create an AppSecLogger.
   *
   * @param {Object} meta - The default metadata object for the logger.
   * The logger will add and populate these fields by default for every log record,
   * unless overridden while logging: `logger.log({ defaultMeta: overriddenValue })`.
   *
   * @param {Object} [logRecordSchema={}] - An optional JSON schema object (https://json-schema.org/draft/2020-12)
   * to enforce on log records.
   * Log records with fields not in the schema will have those fields removed.
   * You should extend the APPLICATION_LOG_FORMAT_V2 schema for consistency.
   *
   * @param {Object} [ajvOptions={}] - Options to pass to the AJV validator
   * for schema validation. `ajvOptions.strict` and `ajvOptions.removeAdditional` are treated as true by default
   * but can be overridden.
   * See AJV documentation for available options: https://ajv.js.org/options.html
   */
  function AppSecLogger(meta) {
    var _os$hostname,
      _this = this;
    var logRecordSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var ajvOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, AppSecLogger);
    // hardcoding all stream levels to info cause appsec logging
    // does not have a concept of level
    this.level = 'info';
    this.fields = _objectSpread(_objectSpread({}, meta), {}, {
      data_version: 1,
      type: 'appsec_event',
      roletype: _config.default.nui.log.roletype,
      application: _config.default.nui.log.application,
      application_version: _config.default.nui.log.version,
      server: _os.default === null || _os.default === void 0 || (_os$hostname = _os.default.hostname) === null || _os$hostname === void 0 ? void 0 : _os$hostname.call(_os.default)
    });
    var applySchemaValidation = _typeof(logRecordSchema) === 'object' && Object.keys(logRecordSchema).length > 0;
    if (applySchemaValidation) {
      // Create a validator instance for schema validation
      var nuiLogValidator = new _NuiLogValidator.NuiLogValidator(_objectSpread(_objectSpread({
        strict: true,
        removeAdditional: true
      }, ajvOptions), {}, {
        schema: logRecordSchema
      }));
      if (nuiLogValidator) {
        // Bind the validate method to maintain proper context
        this.validateFn = nuiLogValidator.validate.bind(nuiLogValidator);
      }
    }
    var _makeLogger = (0, _logProvider.makeLogger)({
        level: this.level,
        defaultMeta: this.fields,
        validateFn: this.validateFn,
        customTransformer: function customTransformer(record) {
          delete record.message;
          delete record.level;
          return record;
        }
      }),
      streams = _makeLogger.streams,
      logger = _makeLogger.logger;
    this.logger = logger;
    this.streams = streams;
    var serializeReq = function serializeReq(req) {
      var _req$headers = req.headers,
        headers = _req$headers === void 0 ? {} : _req$headers,
        _req$url = req.url,
        url = _req$url === void 0 ? '' : _req$url,
        _req$originalUrl = req.originalUrl,
        originalUrl = _req$originalUrl === void 0 ? '' : _req$originalUrl,
        correlationId = req.correlationId;
      return {
        correlation_id: correlationId || headers['concur-correlationid'],
        // Client hostname or IP Proper host name or IP is provided and port. Just one value, no comma-separated list allowed.
        client: (0, _transform.getRemoteAddress)(req),
        // The resource id should be the request uri
        resource_id: originalUrl || url,
        // The user agent header from the request
        'web_access.http_user_agent': headers['user-agent']
      };
    };
    var loggerMethod = function loggerMethod(type) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$req = _ref.req,
        req = _ref$req === void 0 ? {} : _ref$req,
        application = _ref.application,
        application_version = _ref.application_version,
        roletype = _ref.roletype,
        description = _ref.description,
        correlation_id = _ref.correlation_id,
        company_uuid = _ref.company_uuid,
        resource_id = _ref.resource_id,
        caller_id = _ref.caller_id,
        caller_id_type = _ref.caller_id_type,
        customer_user_id = _ref.customer_user_id,
        data_field = _ref.data_field,
        data_field_before = _ref.data_field_before,
        data_field_after = _ref.data_field_after,
        data_diff = _ref.data_diff,
        authz_description = _ref.authz_description,
        change_ticket = _ref.change_ticket,
        external_process = _ref.external_process,
        filename = _ref.filename,
        message = _ref.message;
      var now = new Date();
      var log = _objectSpread(_objectSpread({}, serializeReq(req)), {}, {
        '@timestamp': now.toISOString(),
        category: type,
        message: message || ' '
      });

      // TODO: once the proposal is finalized, let's add in some dev error messaging if missing required keys
      if (caller_id_type) {
        log.caller_id_type = caller_id_type;
      }
      if (caller_id) {
        log.caller_id = caller_id;
      } else {
        // per https://github.concur.com/ap/proposals/tree/master/appsec-logging
        log.caller_id = 'anonymous';
        log.caller_id_type = 'anonymous';
      }
      if (company_uuid) {
        log.company_uuid = company_uuid;
      }
      if (customer_user_id) {
        log.customer_user_id = customer_user_id;
      }
      if (resource_id) {
        log.resource_id = resource_id;
      }
      if (data_field) {
        log.data_field = data_field;
      }
      if (data_field_before) {
        log.data_field_before = data_field_before;
      }
      if (data_field_after) {
        log.data_field_after = data_field_after;
      }
      if (data_diff) {
        log.data_diff = data_diff;
      }
      if (authz_description) {
        log.authz_description = authz_description;
      }
      if (change_ticket) {
        log.change_ticket = change_ticket;
      }
      if (external_process) {
        log.external_process = external_process;
      }
      if (filename) {
        log.filename = filename;
      }
      if (description) {
        log.description = description;
      }
      if (correlation_id) {
        log.correlation_id = correlation_id;
      }

      // allow consumer overrides to default values from config
      if (application) {
        log.application = application;
      }
      if (application_version) {
        log.application_version = application_version;
      }
      if (roletype) {
        log.roletype = roletype;
      }
      if (application || application_version || roletype) {
        _this.logger.configure({
          level: _this.level,
          transports: _this.streams,
          defaultMeta: _objectSpread(_objectSpread({}, _this.fields), {}, {
            application: application,
            application_version: application_version,
            roletype: roletype
          })
        });
      }

      // create record copy
      var copy = _objectSpread({}, log);

      // if copy has truthy correlation_id
      if (copy.correlation_id) {
        var _copy$req;
        // then delete copy.req.correlation_id
        copy === null || copy === void 0 || (_copy$req = copy.req) === null || _copy$req === void 0 || delete _copy$req.correlation_id;
      }

      // move each key of copy.req to copy
      Object.entries(copy.req || {}).forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          value = _ref3[1];
        copy[key] = value;
      });

      // sanitize: delete these top level keys
      delete copy.req;
      delete copy.name;
      delete copy.pid;
      delete copy.msg;
      delete copy.time;
      delete copy.src;
      delete copy.v;
      delete copy.hostname;
      delete copy.level;
      _this.logger.info(copy);
    };
    Object.entries(EventType).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        eventName = _ref5[1];
      AppSecLogger.prototype[key] = loggerMethod.bind(_this, eventName);
    });
  }
  _createClass(AppSecLogger, [{
    key: "log",
    value: function log(category) {
      var type = Object.keys(EventType).find(function (key) {
        return EventType[key] === category;
      });
      if (!type) {
        throw new Error("Unsupported event type: ".concat(category));
      }
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      return this[type].apply(this, rest);
    }
  }]);
  return AppSecLogger;
}();
/** A new instance of AppSecLogger. */
var _default = exports.default = new AppSecLogger();